var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('rkm-area',{attrs:{"type":"fieldset","title":"Condição de Saúde em Geral"}},[_c('FormCondicao',{attrs:{"data":_vm.data}})],1),_c('rkm-area',{attrs:{"type":"fieldset","title":"Cidadão em situação de rua"}},[_c('FormSituacaoRua',{attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }